import { useEffect, useState } from 'react';
import NextHead from 'next/head';
import client from 'api/apollo-client';

import { getServerPageGetPassword } from 'api/graphql-helper';
import { PasswordPageFieldsFragment } from 'api/graphql-types';
import { BaseModule } from 'modules/base-module/base-module';
import { ModuleBuilder } from 'modules/module-builder/module-builder';
import IntroHeader, { IModule } from 'modules/intro-header/intro-header';

export interface IPasswordLayout {
	locale?: string;
	slug?: string;
	children?: React.JSX.Element | React.JSX.Element[];
	pageData?: PasswordPageFieldsFragment | null;
}

export const PasswordLayout = ({
	locale,
	slug,
	children,
	pageData: initialPageData
}: IPasswordLayout): React.JSX.Element => {
	const [pageData, setPageData] = useState<PasswordPageFieldsFragment | null | undefined>(initialPageData);

	const getPageData = async (): Promise<void> => {
		if (initialPageData) return;
		const results = await getServerPageGetPassword({ variables: { locale } }, client);
		const attributes = results?.props?.data.passwordProtectionPasswordPage?.data.attributes;
		setPageData(attributes);
	};

	useEffect(() => {
		if (!initialPageData) {
			getPageData();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [initialPageData]);

	return (
		<>
			<NextHead>
				<meta name="robots" content="noindex, nofollow" key="noindex" />
			</NextHead>
			{pageData?.header && (
				<BaseModule
					defaultModuleOptions={{
						backgroundColor: pageData.header.backgroundColor || 'white',
						padding: 'none'
					}}
				>
					<IntroHeader module={pageData.header as IModule} slug={slug || '/'} />
				</BaseModule>
			)}
			{children}
			{pageData?.modules && <ModuleBuilder modules={pageData.modules} slug={slug || '/'} />}
		</>
	);
};

export default PasswordLayout;
